import React from "react";

function GeneralCpd() {
  return <div></div>;
}

export default GeneralCpd;
